// extracted by mini-css-extract-plugin
export var banner = "_il-0";
export var closeButton = "_il-2";
export var greenCheckmark = "_il-3";
export var hereLink = "_il-4";
export var titleIcon = "_il-1";